export default "__VITE_ASSET__9fede7bf__"